module.exports = __webpack_public_path__ + "static/media/photo_hotspot.e198cd64.svg";